import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import { api, sendAsync } from "../../../app/applicationSlice";
import { RootState, RootThunk, RootThunkApi } from "../../../app/store";
import { Tenant } from "../../../models/tenant";
import * as service from "../../../services/setting";

interface settingState {
  tenant?: Tenant;
  settings: any;
}

const initialState: settingState = {
  settings: [],
};

const settingSlice = createSlice({
  name: "settingSlice",
  initialState,
  reducers: {
    setDetail: (state, action) => {
      state.tenant = action.payload.tenant;
      state.settings = _.reduce(
        action.payload.functionList,
        (acc, { type, value }) => ({
          ...acc,
          [type]: value === "true" ? true : value === "false" ? false : value,
        }),
        {}
      );
    },
  },
});

export const { setDetail } = settingSlice.actions;

export const selectTenant = (state: RootState) => state.settinglable.tenant;

export const selectSettings = (state: RootState): any =>
  state.settinglable.settings;

export const saveSettingLabel = createAsyncThunk<
  void,
  service.SettingMessageParams,
  RootThunkApi
>("setting/getSettingStatus", async (body, api) => {
  return sendAsync(service.getSettingSave(body), api);
});

export function getSettingDetail(): RootThunk {
  return api(service.getSettingDetail(), (data, dispatch) => {
    dispatch(setDetail(data));
  });
}

export default settingSlice.reducer;
